/**
 * @generated SignedSource<<8097671cf4f00afed545275f7fcef987>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type TodoStatus = "DONE" | "PENDING";
import { FragmentRefs } from "relay-runtime";
export type TodoListItemSubTodo_todo$data = {
  readonly canChangeStatus: boolean;
  readonly canWrite: boolean;
  readonly id: string;
  readonly ordinal: string;
  readonly response: {
    readonly __typename: string;
  } | null;
  readonly status: TodoStatus;
  readonly " $fragmentSpreads": FragmentRefs<"TodoCircleStatusWithResponse_todo" | "TodoFooterCircleStatus_todo" | "TodoListItemFooter_todo" | "TodoListItemMainContentDetails_todo" | "TodoListItemMainContentText_todo" | "TodoListItemPriority_todo" | "TodoListItemSubTodoResponse_todo">;
  readonly " $fragmentType": "TodoListItemSubTodo_todo";
};
export type TodoListItemSubTodo_todo$key = {
  readonly " $data"?: TodoListItemSubTodo_todo$data;
  readonly " $fragmentSpreads": FragmentRefs<"TodoListItemSubTodo_todo">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TodoListItemSubTodo_todo",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "status",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "ordinal",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "response",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canWrite",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "canChangeStatus",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoFooterCircleStatus_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoCircleStatusWithResponse_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemSubTodoResponse_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentText_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemPriority_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemFooter_todo"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TodoListItemMainContentDetails_todo"
    }
  ],
  "type": "Todo",
  "abstractKey": null
};

(node as any).hash = "826272ce9e725513ac2da3bc67fc2325";

export default node;
